import React from 'react';
import CommunityPrivacyPage from '@/components/cms/CommunityPrivacyPage';

const PrivacyPolicy = () => {
  return <CommunityPrivacyPage />;
};

export default PrivacyPolicy;